import { render, staticRenderFns } from "./TariffTabs.vue?vue&type=template&id=4a158d6f&scoped=true"
import script from "./TariffTabs.vue?vue&type=script&lang=js"
export * from "./TariffTabs.vue?vue&type=script&lang=js"
import style0 from "./TariffTabs.vue?vue&type=style&index=0&id=4a158d6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a158d6f",
  null
  
)

export default component.exports